import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const FormRevisionSettingsDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/forms/$formId/revisions/$formRevisionId"
					to="/$organizationId/settings/forms/$formId/fields"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Fields
					</Button>
				</Link>
			}
		/>
	)
})
FormRevisionSettingsDetailViewTopBar.displayName = "FormRevisionSettingsDetailViewTopBar"
